App.controller('EditQuestionModalController', EditQuestionModalController);

EditQuestionModalController.$inject = [
    '$rootScope',
    '$scope',
    'questionFactory',
    'question'
];

function EditQuestionModalController($rootScope, $scope, questionFactory, question) {
    var vm = this;

    vm.question = question;

    vm.updateQuestion = updateQuestion;
    vm.closeModal = closeModal;

    function updateQuestion() {
        questionFactory.update(vm.question.id, vm.question).then(function() {
            $rootScope.$broadcast('questionUpdated', vm.question);

            vm.closeModal();
        });
    }

    function closeModal() {
        $scope.$hide();
    }
}